import React from "react";
import { Alert, Paper } from "@mui/material";
import { CampaignTemplateInfoProps } from "../../../interfaces/campaignConfig";

const DocumentGenerationTemplateInfo: React.FC<CampaignTemplateInfoProps> = ({ inputsState }) => {
    return (
        <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
            <Alert severity="info">
                Make sure the fields in your Excel file match the template placeholders.
            </Alert>
        </Paper>
    );
};

export default DocumentGenerationTemplateInfo;
